import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "@/app/providers/Firebase";
import { tourRepository } from "@/data/repositories/tourRepository";
import Tour from "@/models/Tour";

export function useMyTours(userId?: string) {
  const [tours, setTours] = useState<Tour[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!userId) {
      setTours([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    return onSnapshot(
      collection(db, "users", userId, "tours"),
      async snapshot => {
        const ids = snapshot.docs.map(doc => doc.id);
        const resolved = await Promise.all(
          ids.map(id => tourRepository.getById(id))
        );
        setTours(resolved.filter(Boolean) as Tour[]);
        setLoading(false);
      },
      error => {
        console.error("Unable to load tour memberships:", error);
        setTours([]);
        setLoading(false);
      }
    );
  }, [userId]);
  return { tours, loading };
}
